import React, {FC, useState, useEffect, useCallback, useRef, useMemo} from 'react';
import styled from 'styled-components';
import HeroSection from './HeroSection/Loadable';
import RecentNews from './RecentNews/Loadable';
import Events from './Events/Loadable';
import OurClients from './OurClients/Loadable';
import ScrollToTop from '../../containers/ScrollToTop';

import CustomHelmet from '../../components/Helmet/Loadable';
import {BASE_URL} from '../../config/config';
import SetCriteriaPopup from './SetCriteriaPopup/Loadable';
import { makeSelectLoadingUserInfo, makeSelectUserInfo, makeSelectUserRole } from '../App/selectors';
import { useSelector } from 'react-redux';
import {saveItem, getItem} from '../../utils/LocalStorageService'
import moment from 'moment';
import roles from '../../config/roles';
import StorageKeys from '../../config/storage'
import FeaturedJobs from './FeaturedJobs/Loadable';
import InfoSection from './InfoSection/Loadable';
import YourOpporutnities from './YourOpportunities/Loadable';
import Container from '../../components/Layout/Container/Loadable';
import "../../assets/animate.css"

// function USE
const HomePage: FC = () => {

  const refRest = useRef<HTMLDivElement>(null);

  const apiUrl  : string | undefined = BASE_URL;
  const [modal0pen, setModal0pen] = useState<boolean>(false);

  //fali user loading
  const loading = useSelector(makeSelectLoadingUserInfo);
  const user = useSelector(makeSelectUserInfo);
  const role = useSelector(makeSelectUserRole);

  const isInViewport2 = useIsInViewport(refRest);

  useEffect(() => {
    const date = getItem(StorageKeys.favourite_jobs_date + '_'  + user.id);
    const dateDiff = moment().diff(date, 'minutes')
    const isValid = !date ? true : dateDiff >= 0 ? true : false; 
    if(user && role === roles.USER && user.criteria !== 1  && isValid && loading === false){
      setModal0pen(user.criteria === 0 ? true : true)
     }
  }, [user, loading, role]);
  
  const setModalOpenWrapper = useCallback(()=> {
      const date = moment().add(7, 'days').toISOString();
      setModal0pen(false);
      saveItem(StorageKeys.favourite_jobs_date + "_" + user.id , date)
  },[user])

  return (
    <>
      <CustomHelmet
        title={'Oglasi za Posao | Razvoj kompanija i pojedinaca'}
        ogTitle={'Oglasi za Posao | Razvoj kompanija i pojedinaca'}
        description={'Tražite ili nudite posao? Uz raznovrsnu ponudu poslova, loop pomaže kandidatima i poslodavcima da pronađu jedni druge. Proverite zašto smo jedinstveni na tržištu!'}
        ogDescription={'Tražite ili nudite posao? Uz raznovrsnu ponudu poslova, loop pomaže kandidatima i poslodavcima da pronađu jedni druge. Proverite zašto smo jedinstveni na tržištu!'}
        ogImage={apiUrl ? apiUrl.substring(0, apiUrl.length - 4) + '/images/home_og.png' :  '' }
      />
      <HomeWrapper className="home-page">
        <ScrollToTop />
        <HeroSection />
        <Container>
          <InfoSection/>
        </Container>
        <div ref={refRest}>
          {isInViewport2 &&
          <Container>
            <FeaturedJobs />
            <YourOpporutnities />
            <RecentNews />
            <Events />
            <OurClients /> 
            <SetCriteriaPopup
              closeModal={setModalOpenWrapper}
              isOpen={modal0pen}
            />
          </Container>}
        </div>
      </HomeWrapper>
    </>
  )
}

function useIsInViewport(ref: any) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  const observer = useMemo(
    () => 
      new IntersectionObserver(([entry]) => {
      if(entry.intersectionRatio > 0) {
        setIsIntersecting(true)
      }
    }), []);

  useEffect(() => {
    setTimeout(() => {
      if(ref.current) {
        observer.observe(ref.current);
      }
    }, [500])

    return () => {
      observer.disconnect();
    };
  }, [ref, observer]);

  return isIntersecting;
}

const HomeWrapper = styled.div`

  &.home-page {

    .filters {

      &__additional {

        @media (max-width: 767px) {
          display: none;
        }
      }

      &__input {

        @media (max-width: 767px) {
          display: none;
        }
      }
    }
  }
`;

export default HomePage;
